// Mock Data Provider for Frontend Demo / Standalone Testing
import { User, Tenant } from '../../stores/authStore'

export const mockUser: User = {
  id: 'usr_demo_1001',
  email: 'demo@kaseb.app',
  full_name: 'مدیر فروشگاه',
  phone: '09123456789',
  avatar_url: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
  is_active: true,
  is_superuser: true,
  is_verified: true,
  locale: 'fa',
  timezone: 'Asia/Tehran',
  tenant_id: 'tnt_demo_1001',
  roles: [
    {
      id: 'role_admin',
      name: 'admin',
      display_name: 'مدیر سیستم',
      permissions: [{ id: 'p1', name: 'all', resource: '*', action: '*' }]
    }
  ],
  last_login: new Date().toISOString()
}

export const mockTenant: Tenant = {
  id: 'tnt_demo_1001',
  name: 'فروشگاه کسب کار',
  slug: 'kaseb-store',
  primary_color: '#4f46e5',
  is_active: true,
  settings: {}
}

// LocalStorage persistence helpers for full offline operation
function getStorage<T>(key: string, defaultData: T): T {
  try {
    const data = localStorage.getItem(`kaseb_db_${key}`)
    if (data) return JSON.parse(data)
  } catch (e) {
    console.warn(`Error reading kaseb_db_${key} from LocalStorage`, e)
  }
  return defaultData
}

function setStorage<T>(key: string, value: T): void {
  try {
    localStorage.setItem(`kaseb_db_${key}`, JSON.stringify(value))
  } catch (e) {
    console.warn(`Error writing kaseb_db_${key} to LocalStorage`, e)
  }
}

const initialCategories = [
  { id: 'cat_1', name: 'کالای دیجیتال و الکترونیک', slug: 'digital', description: 'انواع لپ‌تاپ، موبایل و لوازم جانبی', is_active: true },
  { id: 'cat_2', name: 'پوشاک و مد', slug: 'clothing', description: 'لباس‌های مردانه و زنانه', is_active: true },
  { id: 'cat_3', name: 'لوازم خانگی', slug: 'home', description: 'تجهیزات منزل و آشپزخانه', is_active: true },
  { id: 'cat_4', name: 'مواد غذایی و آشامیدنی', slug: 'food', description: 'انواع خوراکی و نوشیدنی', is_active: true }
]

const initialBrands = [
  { id: 'br_1', name: 'سامسونگ', slug: 'samsung', logo_url: '', is_active: true },
  { id: 'br_2', name: 'ایسوس', slug: 'asus', logo_url: '', is_active: true },
  { id: 'br_3', name: 'سونی', slug: 'sony', logo_url: '', is_active: true },
  { id: 'br_4', name: 'ال‌جی', slug: 'lg', logo_url: '', is_active: true },
  { id: 'br_5', name: 'کاله', slug: 'kalleh', logo_url: '', is_active: true }
]

const initialUnits = [
  { id: 'un_1', name: 'عدد', symbol: 'عدد', is_decimal: false },
  { id: 'un_2', name: 'کیلوگرم', symbol: 'kg', is_decimal: true },
  { id: 'un_3', name: 'بسته', symbol: 'بسته', is_decimal: false },
  { id: 'un_4', name: 'متر', symbol: 'm', is_decimal: true }
]

const initialProducts = [
  {
    id: 'prod_1',
    title: 'لپ‌تاپ ایسوس مدل ROG Strix',
    name: 'لپ‌تاپ ایسوس مدل ROG Strix',
    sku: 'LAP-ASUS-001',
    barcode: '626000000001',
    description: 'لپ‌تاپ گیمینگ قدرتمند پردازنده i7 رم 16 گیگابایت',
    category_id: 'cat_1',
    brand_id: 'br_2',
    unit_id: 'un_1',
    price: 65000000,
    cost_price: 58000000,
    compare_at_price: 70000000,
    sku_code: 'LAP-ASUS-001',
    stock_quantity: 12,
    stock: 12,
    min_stock_level: 3,
    max_stock_level: 25,
    reorder_point: 5,
    status: 'ACTIVE',
    is_active: true,
    track_inventory: true,
    images: ['https://images.unsplash.com/photo-1603302576837-37561b2e2302?w=400'],
    created_at: '2026-07-01T10:00:00Z',
    updated_at: '2026-07-28T12:00:00Z'
  },
  {
    id: 'prod_2',
    title: 'گوشی موبایل سامسونگ Galaxy S24 Ultra',
    name: 'گوشی موبایل سامسونگ Galaxy S24 Ultra',
    sku: 'MOB-SAMS-002',
    barcode: '626000000002',
    description: 'گوشی پرچمدار سامسونگ 256 گیگابایت حافظه داخلی',
    category_id: 'cat_1',
    brand_id: 'br_1',
    unit_id: 'un_1',
    price: 72000000,
    cost_price: 65000000,
    compare_at_price: 75000000,
    sku_code: 'MOB-SAMS-002',
    stock_quantity: 8,
    stock: 8,
    min_stock_level: 2,
    max_stock_level: 15,
    reorder_point: 4,
    status: 'ACTIVE',
    is_active: true,
    track_inventory: true,
    images: ['https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=400'],
    created_at: '2026-07-05T14:30:00Z',
    updated_at: '2026-07-29T09:15:00Z'
  },
  {
    id: 'prod_3',
    title: 'هدفون بی‌سیم سونی WH-1000XM5',
    name: 'هدفون بی‌سیم سونی WH-1000XM5',
    sku: 'AUD-SONY-003',
    barcode: '626000000003',
    description: 'هدفون نویزکنسلینگ حرفه‌ای با قابلیت نگهداری شارژ ۳۰ ساعت',
    category_id: 'cat_1',
    brand_id: 'br_3',
    unit_id: 'un_1',
    price: 18500000,
    cost_price: 15500000,
    compare_at_price: 20000000,
    sku_code: 'AUD-SONY-003',
    stock_quantity: 2,
    stock: 2,
    min_stock_level: 5,
    max_stock_level: 20,
    reorder_point: 5,
    status: 'ACTIVE',
    is_active: true,
    track_inventory: true,
    images: ['https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400'],
    created_at: '2026-07-10T11:20:00Z',
    updated_at: '2026-07-30T15:00:00Z'
  },
  {
    id: 'prod_4',
    title: 'تلویزیون ۵۵ اینچ OLED ال‌جی',
    name: 'تلویزیون ۵۵ اینچ OLED ال‌جی',
    sku: 'TV-LG-004',
    barcode: '626000000004',
    description: 'تلویزیون هوشمند 4K کیفیت تصویر فوق‌العاده',
    category_id: 'cat_3',
    brand_id: 'br_4',
    unit_id: 'un_1',
    price: 59000000,
    cost_price: 51000000,
    compare_at_price: 64000000,
    sku_code: 'TV-LG-004',
    stock_quantity: 5,
    stock: 5,
    min_stock_level: 2,
    max_stock_level: 10,
    reorder_point: 3,
    status: 'ACTIVE',
    is_active: true,
    track_inventory: true,
    images: ['https://images.unsplash.com/photo-1593784991095-a205069470b6?w=400'],
    created_at: '2026-07-12T08:00:00Z',
    updated_at: '2026-07-25T11:00:00Z'
  },
  {
    id: 'prod_5',
    title: 'قهوه اسپرسو کاله ۱ کیلوگرمی',
    name: 'قهوه اسپرسو کاله ۱ کیلوگرمی',
    sku: 'FOD-KALLEH-005',
    barcode: '626000000005',
    description: 'دان قهوه ترکیبی ۸۰٪ عربیکا با رست مدیوم',
    category_id: 'cat_4',
    brand_id: 'br_5',
    unit_id: 'un_2',
    price: 850000,
    cost_price: 650000,
    compare_at_price: 950000,
    sku_code: 'FOD-KALLEH-005',
    stock_quantity: 45,
    stock: 45,
    min_stock_level: 10,
    max_stock_level: 100,
    reorder_point: 15,
    status: 'ACTIVE',
    is_active: true,
    track_inventory: true,
    images: ['https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=400'],
    created_at: '2026-07-15T16:00:00Z',
    updated_at: '2026-07-31T01:00:00Z'
  }
]

const initialUsers = [
  {
    id: 'usr_1',
    full_name: 'مدیر فروشگاه',
    email: 'admin@kaseb.app',
    phone: '09123456789',
    role_name: 'مدیر سیستم',
    is_active: true,
    created_at: '2026-07-01T00:00:00Z'
  },
  {
    id: 'usr_2',
    full_name: 'رضا کریمی',
    email: 'karimi@kaseb.app',
    phone: '09129876543',
    role_name: 'صندوق‌دار',
    is_active: true,
    created_at: '2026-07-15T00:00:00Z'
  },
  {
    id: 'usr_3',
    full_name: 'سارا محمدی',
    email: 'mohammadi@kaseb.app',
    phone: '09125554433',
    role_name: 'انباردار',
    is_active: true,
    created_at: '2026-07-20T00:00:00Z'
  }
]

const initialRoles = [
  { id: 'role_1', name: 'مدیر سیستم', description: 'دسترسی کامل به تمام بخش‌های برنامه', permissions_count: 48 },
  { id: 'role_2', name: 'صندوق‌دار', description: 'دسترسی به بخش فروشگاه و ثبت فاکتور', permissions_count: 12 },
  { id: 'role_3', name: 'انباردار', description: 'دسترسی به انبارداری و ثبت ورود/خروج کالا', permissions_count: 18 },
  { id: 'role_4', name: 'حسابدار', description: 'دسترسی به گزارشات مالی و پرداخت‌ها', permissions_count: 24 }
]

const initialCustomers = [
  { id: 'cust_1', name: 'علی حسینی', phone: '09121112233', email: 'hoseini@gmail.com', address: 'تهران، ونک', total_purchases: 85000000, is_active: true },
  { id: 'cust_2', name: 'زهرا احمدی', phone: '09124445566', email: 'ahmadi@gmail.com', address: 'اصفهان، خیابان خاقانی', total_purchases: 42000000, is_active: true },
  { id: 'cust_3', name: 'مریم ابراهیمی', phone: '09127778899', email: 'ebrahimi@gmail.com', address: 'شیراز، معالی آباد', total_purchases: 19500000, is_active: true }
]

const initialPayments = [
  { id: 'pay_1', payment_number: 'PAY-2026-01', amount: 78480000, payment_method: 'کارت‌خوان', customer_name: 'علی حسینی', created_at: '2026-07-30T16:20:00Z', status: 'موفق' },
  { id: 'pay_2', payment_number: 'PAY-2026-02', amount: 19620000, payment_method: 'نقدی', customer_name: 'رضا کریمی', created_at: '2026-07-31T02:10:00Z', status: 'موفق' },
  { id: 'pay_3', payment_number: 'PAY-2026-03', amount: 45000000, payment_method: 'کارت به کارت', customer_name: 'تامین قطعات نوین', created_at: '2026-08-01T10:00:00Z', status: 'موفق' }
]

let mockCategories = getStorage('categories', initialCategories)
let mockBrands = getStorage('brands', initialBrands)
let mockUnits = getStorage('units', initialUnits)
let mockProducts = getStorage('products', initialProducts)
let mockUsers = getStorage('users', initialUsers)
let mockRoles = getStorage('roles', initialRoles)
let mockCustomers = getStorage('customers', initialCustomers)
let mockPayments = getStorage('payments', initialPayments)

const initialWarehouses = [
  { id: 'wh_1', name: 'انبار مرکزی تهران', code: 'WH-TEH-01', address: 'تهران، خیابان آزادی، پلاک ۱۲۰', phone: '02166000000', is_active: true, is_default: true },
  { id: 'wh_2', name: 'انبار خاوران', code: 'WH-KHAV-02', address: 'تهران، جاده خاوران، شهرک صنعتی', phone: '02133000000', is_active: true, is_default: false },
  { id: 'wh_3', name: 'انبار اصفهان', code: 'WH-ISF-03', address: 'اصفهان، شهرک صنعتی جی', phone: '03133000000', is_active: true, is_default: false }
]

const initialSuppliers = [
  {
    id: 'sup_1',
    name: 'شرکت بازرگانی آریا تکنولوژی',
    contact_name: 'مهندس احمدی',
    email: 'info@ariatech.ir',
    phone: '02188889999',
    address: 'تهران، خیابان ولیعصر، برج سایه',
    payment_terms: 'NET30',
    tax_number: '10100000001',
    is_active: true,
    balance: 120000000
  },
  {
    id: 'sup_2',
    name: 'تامین قطعات نوین الکترونیک',
    contact_name: 'آقای رضایی',
    email: 'sales@novinelec.com',
    phone: '02177665544',
    address: 'تهران، لاله‌زار جنوبی، پاساژ تابان',
    payment_terms: 'NET15',
    tax_number: '10100000002',
    is_active: true,
    balance: 45000000
  },
  {
    id: 'sup_3',
    name: 'صنایع بسته بندی و بازرگانی پارس',
    contact_name: 'خانم محمدی',
    email: 'order@parspack.ir',
    phone: '02144332211',
    address: 'کرج، جاده مخصوص، کیلومتر ۱۸',
    payment_terms: 'CASH',
    tax_number: '10100000003',
    is_active: true,
    balance: 0
  }
]

const initialPurchaseOrders = [
  {
    id: 'po_1',
    order_number: 'PO-2026-001',
    supplier_id: 'sup_1',
    supplier_name: 'شرکت بازرگانی آریا تکنولوژی',
    warehouse_id: 'wh_1',
    status: 'RECEIVED',
    total_amount: 195000000,
    expected_date: '2026-07-20',
    created_at: '2026-07-15T10:00:00Z',
    items: [
      { id: 'poi_1', product_id: 'prod_1', product_name: 'لپ‌تاپ ایسوس مدل ROG Strix', quantity: 3, unit_price: 58000000, total_price: 174000000 },
      { id: 'poi_2', product_id: 'prod_3', product_name: 'هدفون بی‌سیم سونی WH-1000XM5', quantity: 2, unit_price: 15500000, total_price: 21000000 }
    ]
  },
  {
    id: 'po_2',
    order_number: 'PO-2026-002',
    supplier_id: 'sup_2',
    supplier_name: 'تامین قطعات نوین الکترونیک',
    warehouse_id: 'wh_1',
    status: 'APPROVED',
    total_amount: 130000000,
    expected_date: '2026-08-05',
    created_at: '2026-07-28T14:00:00Z',
    items: [
      { id: 'poi_3', product_id: 'prod_2', product_name: 'گوشی موبایل سامسونگ Galaxy S24 Ultra', quantity: 2, unit_price: 65000000, total_price: 130000000 }
    ]
  }
]

const initialBills = [
  {
    id: 'bill_1',
    bill_number: 'BIL-2026-001',
    purchase_order_id: 'po_1',
    supplier_id: 'sup_1',
    supplier_name: 'شرکت بازرگانی آریا تکنولوژی',
    status: 'PAID',
    total_amount: 195000000,
    paid_amount: 195000000,
    due_date: '2026-08-15',
    created_at: '2026-07-20T11:00:00Z'
  },
  {
    id: 'bill_2',
    bill_number: 'BIL-2026-002',
    purchase_order_id: 'po_2',
    supplier_id: 'sup_2',
    supplier_name: 'تامین قطعات نوین الکترونیک',
    status: 'PENDING',
    total_amount: 130000000,
    paid_amount: 45000000,
    due_date: '2026-08-28',
    created_at: '2026-07-29T09:30:00Z'
  }
]

const initialSales = [
  {
    id: 'sale_1',
    invoice_number: 'INV-2026-101',
    total_amount: 72000000,
    discount_amount: 0,
    tax_amount: 6480000,
    final_amount: 78480000,
    status: 'COMPLETED',
    payment_status: 'PAID',
    payment_method: 'CARD',
    customer_name: 'مشتری حضوری',
    created_at: '2026-07-30T16:20:00Z',
    items: [
      { id: 'si_1', product_id: 'prod_2', product_name: 'گوشی موبایل سامسونگ Galaxy S24 Ultra', quantity: 1, unit_price: 72000000, total_price: 72000000 }
    ]
  },
  {
    id: 'sale_2',
    invoice_number: 'INV-2026-102',
    total_amount: 18500000,
    discount_amount: 500000,
    tax_amount: 1620000,
    final_amount: 19620000,
    status: 'COMPLETED',
    payment_status: 'PAID',
    payment_method: 'CASH',
    customer_name: 'رضا کریمی',
    created_at: '2026-07-31T02:10:00Z',
    items: [
      { id: 'si_2', product_id: 'prod_3', product_name: 'هدفون بی‌سیم سونی WH-1000XM5', quantity: 1, unit_price: 18500000, total_price: 18500000 }
    ]
  }
]

const initialTransfers = [
  {
    id: 'tr_1',
    transfer_number: 'TRF-2026-001',
    source_warehouse_id: 'wh_1',
    source_warehouse_name: 'انبار مرکزی تهران',
    destination_warehouse_id: 'wh_2',
    destination_warehouse_name: 'انبار خاوران',
    status: 'COMPLETED',
    notes: 'انتقال برای تحویل سفارشی',
    created_at: '2026-07-26T14:00:00Z',
    items: [
      { id: 'tri_1', product_id: 'prod_5', product_name: 'قهوه اسپرسو کاله ۱ کیلوگرمی', quantity: 10 }
    ]
  }
]

const initialAdjustments = [
  {
    id: 'adj_1',
    adjustment_number: 'ADJ-2026-001',
    warehouse_id: 'wh_1',
    warehouse_name: 'انبار مرکزی تهران',
    reason: 'INVENTORY_COUNT',
    status: 'COMPLETED',
    notes: 'تطبیق انبارگردانی پایان ماه',
    created_at: '2026-07-29T18:00:00Z',
    items: [
      { id: 'adji_1', product_id: 'prod_3', product_name: 'هدفون بی‌سیم سونی WH-1000XM5', quantity_difference: -1 }
    ]
  }
]

let mockWarehouses = getStorage('warehouses', initialWarehouses)
let mockSuppliers = getStorage('suppliers', initialSuppliers)
let mockPurchaseOrders = getStorage('purchase_orders', initialPurchaseOrders)
let mockBills = getStorage('bills', initialBills)
let mockSales = getStorage('sales', initialSales)
let mockTransfers = getStorage('transfers', initialTransfers)
let mockAdjustments = getStorage('adjustments', initialAdjustments)

let mockShifts = [
  {
    id: 'sh_1',
    user_id: 'usr_demo_1001',
    user_name: 'مدیر فروشگاه',
    status: 'OPEN',
    starting_cash: 5000000,
    total_sales: 98100000,
    opened_at: '2026-07-31T08:00:00Z',
    closed_at: null
  }
]

let mockCart = {
  items: [],
  subtotal: 0,
  tax: 0,
  discount: 0,
  total: 0
}

function paginate<T>(items: T[], params?: any) {
  const page = Number(params?.page) || 1
  const size = Number(params?.limit || params?.size) || 10
  const start = (page - 1) * size
  const paginated = items.slice(start, start + size)
  return {
    items: paginated,
    total: items.length,
    page,
    size,
    pages: Math.ceil(items.length / size) || 1
  }
}

export function handleMockRoute(method: string, url: string, body?: any): any {
  const cleanUrl = url.replace(/^\/api\/v1/, '').split('?')[0]

  // Auth endpoints
  if (cleanUrl.startsWith('/auth/login') || cleanUrl.startsWith('/auth/register')) {
    const email = body?.email || ''
    const password = body?.password || ''

    // Look up user in mockUsers by email, phone or name
    const foundUser = mockUsers.find((u: any) =>
      (u.email && u.email.toLowerCase() === email.toLowerCase()) ||
      (u.phone && u.phone === email) ||
      (u.full_name && u.full_name.toLowerCase().includes(email.toLowerCase()))
    )

    const userRoleName = foundUser?.role_name || (email.includes('karimi') ? 'صندوق‌دار' : email.includes('mohammadi') ? 'انباردار' : email.includes('rezaei') ? 'حسابدار' : 'مدیر سیستم')

    const loggedUser = {
      id: foundUser?.id || 'usr_' + Date.now(),
      email: foundUser?.email || email || 'admin@kaseb.app',
      full_name: foundUser?.full_name || (email.includes('karimi') ? 'رضا کریمی (صندوق‌دار)' : email.includes('mohammadi') ? 'سارا محمدی (انباردار)' : 'مدیر فروشگاه'),
      phone: foundUser?.phone || '09123456789',
      is_active: true,
      is_superuser: userRoleName === 'مدیر سیستم',
      is_verified: true,
      locale: 'fa',
      timezone: 'Asia/Tehran',
      tenant_id: 'ten_1',
      role_name: userRoleName,
      roles: [
        {
          id: 'role_' + userRoleName,
          name: userRoleName,
          display_name: userRoleName,
          description: `نقش ${userRoleName}`,
          permissions: []
        }
      ]
    }

    return {
      access_token: 'demo_access_token_' + Date.now(),
      refresh_token: 'demo_refresh_token_' + Date.now(),
      user: loggedUser,
      tenant: mockTenant
    }
  }
  if (cleanUrl.startsWith('/auth/refresh')) {
    return {
      access_token: 'demo_access_token_' + Date.now(),
      refresh_token: 'demo_refresh_token_' + Date.now()
    }
  }
  if (cleanUrl.startsWith('/auth/me')) {
    return mockUser
  }

  // Products
  if (cleanUrl === '/products') {
    if (method === 'GET') return paginate(mockProducts)
    if (method === 'POST') {
      const name = body?.name || body?.title || 'کالای جدید'
      const price = Number(body?.sale_price ?? body?.price ?? 0)
      const cost_price = Number(body?.cost_price ?? 0)
      const stock = Number(body?.initial_stock ?? body?.stock_quantity ?? body?.stock ?? 0)
      const sku = body?.sku || ('SKU-' + Math.floor(100000 + Math.random() * 900000))
      
      const newProd = {
        id: 'prod_' + Date.now(),
        title: name,
        name: name,
        sku: sku,
        sku_code: sku,
        barcode: body?.barcode || '',
        description: body?.description || '',
        price: price,
        cost_price: cost_price,
        stock_quantity: stock,
        stock: stock,
        status: 'ACTIVE',
        is_active: true,
        track_inventory: true,
        category_id: body?.category_id || null,
        brand_id: body?.brand_id || null,
        unit_id: body?.unit_id || null,
        images: body?.images || [],
        ...body,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      }
      mockProducts.unshift(newProd)
      setStorage('products', mockProducts)
      return newProd
    }
  }
  if (cleanUrl.startsWith('/products/categories')) {
    if (method === 'GET') return paginate(mockCategories)
    if (method === 'POST') {
      const newCat = { id: 'cat_' + Date.now(), is_active: true, ...body }
      mockCategories.push(newCat)
      setStorage('categories', mockCategories)
      return newCat
    }
  }
  if (cleanUrl.startsWith('/products/brands')) {
    if (method === 'GET') return paginate(mockBrands)
    if (method === 'POST') {
      const newBr = { id: 'br_' + Date.now(), is_active: true, ...body }
      mockBrands.push(newBr)
      setStorage('brands', mockBrands)
      return newBr
    }
  }
  if (cleanUrl.startsWith('/products/units')) {
    if (method === 'GET') return mockUnits
    if (method === 'POST') {
      const newUn = { id: 'un_' + Date.now(), is_decimal: false, ...body }
      mockUnits.push(newUn)
      setStorage('units', mockUnits)
      return newUn
    }
  }
  if (cleanUrl.match(/\/products\/[^\/]+$/)) {
    const id = cleanUrl.split('/')[2]
    if (method === 'GET') {
      const p = mockProducts.find(x => x.id === id) || mockProducts[0]
      return { ...p, variants: [], category: mockCategories[0], brand: mockBrands[0], unit: mockUnits[0] }
    }
    if (method === 'PATCH' || method === 'PUT') {
      const index = mockProducts.findIndex(x => x.id === id)
      if (index !== -1) {
        mockProducts[index] = { ...mockProducts[index], ...body, updated_at: new Date().toISOString() }
        setStorage('products', mockProducts)
        return mockProducts[index]
      }
    }
    if (method === 'DELETE') {
      mockProducts = mockProducts.filter(x => x.id !== id)
      setStorage('products', mockProducts)
      return { success: true }
    }
  }

  // Inventory
  if (cleanUrl.startsWith('/inventory/warehouses')) {
    if (method === 'GET') return paginate(mockWarehouses)
    if (method === 'POST') {
      const newWh = { id: 'wh_' + Date.now(), is_active: true, ...body }
      mockWarehouses.push(newWh)
      setStorage('warehouses', mockWarehouses)
      return newWh
    }
  }
  if (cleanUrl.startsWith('/inventory/stock')) {
    return mockProducts.map(p => ({
      product_id: p.id,
      product_name: p.name || p.title,
      warehouse_id: 'wh_1',
      warehouse_name: 'انبار مرکزی تهران',
      quantity: p.stock_quantity ?? p.stock ?? 0,
      min_level: p.min_stock_level || 2,
      reorder_point: p.reorder_point || 5
    }))
  }
  if (cleanUrl.startsWith('/inventory/transfers')) {
    if (method === 'GET') return paginate(mockTransfers)
    if (method === 'POST') {
      const newTr = { id: 'tr_' + Date.now(), transfer_number: 'TRF-' + Date.now(), status: 'PENDING', ...body, created_at: new Date().toISOString() }
      mockTransfers.unshift(newTr)
      setStorage('transfers', mockTransfers)
      return newTr
    }
  }
  if (cleanUrl.startsWith('/inventory/adjustments')) {
    if (method === 'GET') return paginate(mockAdjustments)
    if (method === 'POST') {
      const newAdj = { id: 'adj_' + Date.now(), adjustment_number: 'ADJ-' + Date.now(), status: 'COMPLETED', ...body, created_at: new Date().toISOString() }
      mockAdjustments.unshift(newAdj)
      setStorage('adjustments', mockAdjustments)
      return newAdj
    }
  }

  // Purchase
  if (cleanUrl.startsWith('/purchase/suppliers')) {
    if (method === 'GET') return paginate(mockSuppliers)
    if (method === 'POST') {
      const newSup = { id: 'sup_' + Date.now(), is_active: true, ...body }
      mockSuppliers.push(newSup)
      setStorage('suppliers', mockSuppliers)
      return newSup
    }
  }
  if (cleanUrl.startsWith('/purchase/orders')) {
    if (method === 'GET') return paginate(mockPurchaseOrders)
    if (method === 'POST') {
      const newPo = { id: 'po_' + Date.now(), order_number: 'PO-' + Date.now(), status: 'PENDING', ...body, created_at: new Date().toISOString() }
      mockPurchaseOrders.unshift(newPo)
      setStorage('purchase_orders', mockPurchaseOrders)
      return newPo
    }
  }
  if (cleanUrl.startsWith('/purchase/bills')) {
    if (method === 'GET') return paginate(mockBills)
    if (method === 'POST') {
      const newBill = { id: 'bill_' + Date.now(), bill_number: 'BIL-' + Date.now(), status: 'PENDING', ...body, created_at: new Date().toISOString() }
      mockBills.unshift(newBill)
      setStorage('bills', mockBills)
      return newBill
    }
  }

  // POS
  if (cleanUrl.startsWith('/pos/sales')) {
    if (method === 'GET') return paginate(mockSales)
    if (method === 'POST') {
      const newSale = {
        id: 'sale_' + Date.now(),
        invoice_number: 'INV-' + Math.floor(1000 + Math.random() * 9000),
        status: 'COMPLETED',
        payment_status: 'PAID',
        ...body,
        created_at: new Date().toISOString()
      }
      mockSales.unshift(newSale)
      setStorage('sales', mockSales)
      return newSale
    }
  }
  if (cleanUrl.startsWith('/pos/cart')) {
    return mockCart
  }
  if (cleanUrl.startsWith('/pos/shifts/current')) {
    return mockShifts[0] || null
  }
  if (cleanUrl.startsWith('/pos/shifts')) {
    if (method === 'GET') return paginate(mockShifts)
  }

  // Users
  if (cleanUrl.startsWith('/users')) {
    const parts = cleanUrl.split('/')
    const userId = parts[2]
    if (userId && method === 'DELETE') {
      mockUsers = mockUsers.filter(u => u.id !== userId)
      setStorage('users', mockUsers)
      return { success: true }
    }
    if (userId && (method === 'PATCH' || method === 'PUT')) {
      const idx = mockUsers.findIndex(u => u.id === userId)
      if (idx !== -1) {
        mockUsers[idx] = { ...mockUsers[idx], ...body }
        setStorage('users', mockUsers)
        return mockUsers[idx]
      }
    }
    if (method === 'GET') return paginate(mockUsers)
    if (method === 'POST') {
      const newUser = {
        id: 'usr_' + Date.now(),
        is_active: true,
        created_at: new Date().toISOString(),
        role_name: body?.role_name || 'کاربر',
        ...body
      }
      mockUsers.unshift(newUser)
      setStorage('users', mockUsers)
      return newUser
    }
  }

  // Roles
  if (cleanUrl.startsWith('/roles')) {
    const parts = cleanUrl.split('/')
    const roleId = parts[2]

    if (roleId && method === 'DELETE') {
      mockRoles = mockRoles.filter(r => r.id !== roleId)
      setStorage('roles', mockRoles)
      return { success: true }
    }

    if (roleId && (method === 'PUT' || method === 'PATCH')) {
      const idx = mockRoles.findIndex(r => r.id === roleId || r.name === body?.name)
      if (idx !== -1) {
        mockRoles[idx] = {
          ...mockRoles[idx],
          ...body,
          permissions_count: body?.permissions?.length || mockRoles[idx].permissions_count
        }
        setStorage('roles', mockRoles)
        return mockRoles[idx]
      }
    }

    if (method === 'GET') return paginate(mockRoles)

    if (method === 'POST') {
      const existingIdx = mockRoles.findIndex(r => r.name === body?.name || (body?.id && r.id === body?.id))
      if (existingIdx !== -1) {
        mockRoles[existingIdx] = {
          ...mockRoles[existingIdx],
          ...body,
          permissions_count: body?.permissions?.length || mockRoles[existingIdx].permissions_count
        }
        setStorage('roles', mockRoles)
        return mockRoles[existingIdx]
      }

      const newRole = {
        id: 'role_' + Date.now(),
        permissions_count: body?.permissions?.length || 10,
        ...body
      }
      mockRoles.unshift(newRole)
      setStorage('roles', mockRoles)
      return newRole
    }
  }

  // Customers
  if (cleanUrl.startsWith('/customers')) {
    const parts = cleanUrl.split('/')
    const custId = parts[2]
    if (custId && method === 'DELETE') {
      mockCustomers = mockCustomers.filter(c => c.id !== custId)
      setStorage('customers', mockCustomers)
      return { success: true }
    }
    if (method === 'GET') return paginate(mockCustomers)
    if (method === 'POST') {
      const newCust = {
        id: 'cust_' + Date.now(),
        total_purchases: 0,
        is_active: true,
        ...body
      }
      mockCustomers.unshift(newCust)
      setStorage('customers', mockCustomers)
      return newCust
    }
  }

  // Payments / Purchase Payments
  if (cleanUrl.startsWith('/payments') || cleanUrl.startsWith('/purchase/payments')) {
    const parts = cleanUrl.split('/')
    const payId = parts[2]
    if (payId && method === 'DELETE') {
      mockPayments = mockPayments.filter(p => p.id !== payId)
      setStorage('payments', mockPayments)
      return { success: true }
    }
    if (method === 'GET') return paginate(mockPayments)
    if (method === 'POST') {
      const newPay = {
        id: 'pay_' + Date.now(),
        payment_number: 'PAY-' + Math.floor(1000 + Math.random() * 9000),
        status: 'موفق',
        created_at: new Date().toISOString(),
        ...body
      }
      mockPayments.unshift(newPay)
      setStorage('payments', mockPayments)
      return newPay
    }
  }
}
